import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "@apollo/client";
export default gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment MasterlistingSelectFragment on MasterlistingNode {\n        id\n        displayAddressWithFloor\n        sqft\n        leaseTypeDisplay\n    }\n"])));